import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-datos-usuario-header',
  templateUrl: './datos-usuario-header.component.html',
  styleUrls: ['./datos-usuario-header.component.scss']
})
export class DatosUsuarioHeaderComponent implements OnInit {
  @Input () nro_sumininstro: string = '';
  @Input () nombres: string = '';
  @Input () apellidos: string = '';
  @Input () tipo_documento: string = '';
  @Input () nro_documento: string = '';

  constructor() {

  }

  ngOnInit() {

  }
}
